import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const FLAGS = {
  JP: '🇯🇵', ES: '🇪🇸', FR: '🇫🇷', CN: '🇨🇳', US: '🇺🇸', KR: '🇰🇷',
  GB: '🇬🇧', DE: '🇩🇪', IT: '🇮🇹', RU: '🇷🇺', BR: '🇧🇷', CA: '🇨🇦', AU: '🇦🇺', IN: '🇮🇳',
};

const LANG_NAMES = {
  ja: '日本語', es: 'Español', fr: 'Français', zh: '中文', en: 'English', ko: '한국어',
};

const TIMEZONES = {
  JP: { label: '🇯🇵 东京', hour: 9 },
  CN: { label: '🇨🇳 北京', hour: 8 },
  KR: { label: '🇰🇷 首尔', hour: 9 },
  US: { label: '🇺🇸 纽约', hour: -4 },
  ES: { label: '🇪🇸 马德里', hour: 2 },
  FR: { label: '🇫🇷 巴黎', hour: 2 },
  GB: { label: '🇬🇧 伦敦', hour: 1 },
  DE: { label: '🇩🇪 柏林', hour: 2 },
  AU: { label: '🇦🇺 悉尼', hour: 11 },
  BR: { label: '🇧🇷 巴西利亚', hour: -3 },
};

function getTimeStatus(countryCode) {
  const tz = TIMEZONES[countryCode];
  if (!tz) return { label: '🌍 在线', emoji: '🟢' };
  const now = new Date();
  const localHour = (now.getUTCHours() + tz.hour + 24) % 24;
  if (localHour >= 7 && localHour < 22) return { label: `🟢 ${tz.label} ${localHour}:${String(now.getUTCMinutes()).padStart(2, '0')}`, emoji: '🟢' };
  return { label: `🌙 ${tz.label} ${localHour}:${String(now.getUTCMinutes()).padStart(2, '0')}`, emoji: '🌙' };
}

export default function UserCard({ user, onChat, onAddFriend }) {
  const [reacted,setReacted]=useState(''),[reactionDraft,setReactionDraft]=useState(''),[reactionField,setReactionField]=useState(''),[reactionMsg,setReactionMsg]=useState('');
  const openReaction=field=>{setReactionField(field);setReactionDraft('');setReactionMsg('');};
  const reactTo=async field=>{try{const token=localStorage.getItem('token');await axios.post('/api/profile/reaction',{targetUserId:user.user_id,field,type:'like',comment:reactionDraft.trim()},{headers:{Authorization:'Bearer '+token}});setReacted(field);setReactionField('');setReactionDraft('');setReactionMsg('已发送，对方接受后即可匹配');}catch(e){setReactionMsg(e.response?.data?.error||'发送失败');}};
  const navigate = useNavigate();
  const timeStatus = getTimeStatus(user.country_code);
  const flag = FLAGS[user.country_code] || '🌍';
  const langName = LANG_NAMES[user.preferred_language] || user.preferred_language;

  return (
    <div className="user-card">
      <div className="user-card-top">
        <div className="user-avatar">
          {user.avatar_url ? (
            <img src={user.avatar_url} alt="" className="user-avatar-img" />
          ) : (
            <div className="avatar-placeholder">
              {user.display_name?.charAt(0)?.toUpperCase() || '?'}
            </div>
          )}
        </div>
        <div className="user-card-info">
          <div className="user-card-name">
            {flag} {user.display_name || user.username}
          </div>
          <div className="user-card-bio">
            {user.bio || '这个人很懒，什么都没写~'}
          </div>
          <div className="user-card-meta">
            <span className="meta-badge lang">
              🗣️ {langName}
            </span>
            <span className="meta-badge time" title={timeStatus.label}>
              {timeStatus.emoji} {timeStatus.label}
            </span>
          </div>
        </div>
      </div>
      {(user.prompt1 || user.prompt2) && <div style={{margin:'8px 0',padding:'9px 10px',borderRadius:8,background:'rgba(255,255,255,.04)',fontSize:'.78rem'}}>{[['prompt1','💬',user.prompt1],['prompt2','✨',user.prompt2]].filter(x=>x[2]).map(([field,icon,text])=><div key={field} style={{marginBottom:field==='prompt1'&&user.prompt2?8:0}}><div style={{display:'flex',gap:6,alignItems:'center'}}><span style={{flex:1}}>{icon} {text}</span><button className="btn btn-secondary" style={{padding:'3px 8px',fontSize:'.7rem'}} onClick={()=>openReaction(field)}>{reacted===field?'✓ 已喜欢':'♥ 喜欢'}</button></div>{reactionField===field&&<div style={{display:'flex',gap:6,marginTop:7}}><input value={reactionDraft} maxLength={180} onChange={e=>setReactionDraft(e.target.value)} placeholder="附一句真诚的话（可选）" style={{flex:1,minWidth:0,padding:'7px 8px'}}/><button className="btn btn-primary" onClick={()=>reactTo(field)} style={{padding:'6px 10px'}}>发送</button></div>}</div>)}</div>}
      {reactionMsg&&<div style={{fontSize:'.72rem',color:'var(--text-dim)',margin:'5px 0'}}>{reactionMsg}</div>}
      <div className="user-card-interests">
        {(user.interests || []).map((i) => (
          <span key={i} className="interest-tag">#{i}</span>
        ))}
      </div>
      <div className="user-card-actions">
        <button className="btn btn-secondary" onClick={() => onAddFriend?.(user.user_id)}>➕ 好友</button>
        <button className="btn btn-primary" onClick={() => onChat?.(user)}>
          💬 聊天
        </button>
        <button className="btn btn-secondary" onClick={() => navigate(`/profile/${user.id}`)}>
          👤 资料
        </button>
      </div>
    </div>
  );
}
